import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckSquare, faSquare } from "@fortawesome/free-solid-svg-icons";

const RecipeFilteredBadgeCard = ({ badge, isSelected, onChecked }) => {
  const handleChecked = () => {
    onChecked(badge, !isSelected);
  };

  return (
    <button className="Row" onClick={handleChecked}>
      <FontAwesomeIcon
        className="Small-Badge Badge-Icon"
        icon={isSelected ? faCheckSquare : faSquare}
      />
      <i className="fa-light fa-square-check"></i>
      <img className="Small-Badge marg-25" src={badge.image} alt={badge.name} />
      <span>{badge.name}</span>
    </button>
  );
};

export default RecipeFilteredBadgeCard;
